import { css } from "@emotion/core";

export const stickyTableHeaderCss = css`
  thead {
    position: sticky;
    top: 0;
    background-color: var(--neutral-6);
    z-index: 1;

    th {
      border-bottom: 1px solid var(--neutral-5);
    }
  }

  tbody tr:first-child td {
    box-shadow: none !important;
  }
`;

